import AppConstants from '../config/app.constants';

let DailyStatService = function ($http, $q) {

    let getDailyStats = (startDate, endDate, branchId) => {
        return $http
            .get(AppConstants.api + `/daily-stats`, {
                params: {
                    startDate,
                    endDate,
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    };



    return {
        getDailyStats,
    };
};

DailyStatService.$inject = ['$http', '$q']

export default DailyStatService;


// WEBPACK FOOTER //
// ./client/app/services/daily-stat.service.js